module.exports = __webpack_public_path__ + "img/40_29.f3f27b78.png";